import { SET_SESSION_DATA, GET_SESSION_DATA, SET_PUBLIC_API_KEY, SET_IS_ERROR, SET_COLLAPSED, SET_IS_PROJECT } from "../actions/userSessionAction"

const initialState = {
  userSession: null
}

const userSessionReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SESSION_DATA:
      return {
        ...state,
        userSession: action.payload
      }
    case GET_SESSION_DATA:
      return {
        ...state
      }
    case SET_PUBLIC_API_KEY:
      return { ...state, publicApiKey: action.payload };
    case SET_IS_ERROR:
      return { ...state, isAcess: action.payload };
    case SET_COLLAPSED:
      return { ...state, isCollepsed: action.payload }
    case SET_IS_PROJECT:
      return { ...state, projectName: action.payload }
    default:
      return state
  }
}

// const userSessionDataReducer =()

export default userSessionReducer
